import React, { useEffect, useState } from 'react';
import LottieIllustration from './LottieIllustration';
import { loadAnimation } from '../utils/loadAnimation';

interface LottieHeroIllustrationProps {
  className?: string;
}

const LottieHeroIllustration: React.FC<LottieHeroIllustrationProps> = ({ className = '' }) => {
  const [animationData, setAnimationData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadHeroAnimation = async () => {
      try {
        setIsLoading(true);
        const animation = await loadAnimation('/animations/Business Analysis.json');
        setAnimationData(animation);
      } catch (error) {
        console.error('Error loading hero animation:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadHeroAnimation();
  }, []);

  if (isLoading) {
    return (
      <div className={`${className} flex items-center justify-center bg-gradient-to-br from-accent/5 to-accent-light/5 rounded-3xl`}>
        <div className="text-center p-8">
          <div className="animate-spin text-4xl mb-4">⏳</div>
          <div className="text-sm dark:text-gray-400 light:text-gray-500">Loading animation...</div>
        </div>
      </div>
    );
  }

  if (!animationData) {
    return (
      <div className={`${className} flex items-center justify-center bg-gradient-to-br from-accent/5 to-accent-light/5 rounded-3xl`}>
        <div className="text-center p-8">
          <div className="text-6xl mb-4">📊</div>
          <div className="text-lg font-semibold dark:text-white light:text-gray-900 mb-2">Business Analysis</div>
          <div className="text-sm dark:text-gray-400 light:text-gray-500">Data-driven insights for your business</div>
        </div>
      </div>
    );
  }

  return (
    <LottieIllustration
      animationData={animationData}
      className={className}
      width="100%"
      height="100%"
      loop={true}
      autoplay={true}
    />
  );
};

export default LottieHeroIllustration;
